import { Dispatch } from 'redux';
import { makeApiBlobRequest } from '../helpers/makeApiBlobRequest';
import { triggerDownload } from '../helpers/triggerDownload';
import { parseFileNameFromHeader } from '../helpers/parseFileNameFromHeader';

export async function downloadCsvReport({ id, dateFrom, dateTo, title, dispatch }: {
  id: string;
  dateFrom: string;
  dateTo: string;
  title?: string;
  dispatch?: Dispatch;
}) {
  const res = await makeApiBlobRequest({
    path: 'admin/downloadCsvReport',
    method: 'POST',
    body: JSON.stringify({ id, dateFrom, dateTo }),
    dispatch,
  });
  if (!res.ok) {
    throw new Error(`Failed to download (${res.status})`);
  }
  const blob = await res.blob();
  const filenameFromHeader = parseFileNameFromHeader(res.headers.get('Content-Disposition'));
  triggerDownload(blob, filenameFromHeader || (title ? `${title}.csv` : null));
}
